import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { createInjectionKey as B } from "../../_utils/vue/create-injection-key.js";
import { warnOnce as U } from "../../_utils/naive/warn.js";
import I from "../../_mixins/use-form-item.js";
import x from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import s from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import D from "../../_mixins/use-config.js";
import { call as f } from "../../_utils/vue/call.js";
import { watchEffect as P, inject as V } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as u, toRef as j } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const q = {
  name: String,
  value: {
    type: [String, Number, Boolean],
    default: "on"
  },
  checked: {
    type: Boolean,
    default: void 0
  },
  defaultChecked: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  },
  label: String,
  size: String,
  onUpdateChecked: [Function, Array],
  "onUpdate:checked": [Function, Array],
  // deprecated
  checkedValue: {
    type: Boolean,
    default: void 0
  }
}, E = B("n-radio-group");
function H(t) {
  process.env.NODE_ENV !== "production" && P(() => {
    t.checkedValue !== void 0 && U("radio", "`checked-value` is deprecated, please use `checked` instead.");
  });
  const n = V(E, null), l = I(t, {
    mergedSize(e) {
      const {
        size: d
      } = t;
      if (d !== void 0)
        return d;
      if (n) {
        const {
          mergedSizeRef: {
            value: r
          }
        } = n;
        if (r !== void 0)
          return r;
      }
      return e ? e.mergedSize.value : "medium";
    },
    mergedDisabled(e) {
      return !!(t.disabled || n != null && n.disabledRef.value || e != null && e.disabled.value);
    }
  }), {
    mergedSizeRef: g,
    mergedDisabledRef: c
  } = l, o = u(null), h = u(null), m = u(t.defaultChecked), v = j(t, "checked"), R = x(v, m), i = s(() => n ? n.valueRef.value === t.value : R.value), k = s(() => {
    const {
      name: e
    } = t;
    if (e !== void 0)
      return e;
    if (n)
      return n.nameRef.value;
  }), a = u(!1);
  function C() {
    if (n) {
      const {
        doUpdateValue: e
      } = n, {
        value: d
      } = t;
      f(e, d);
    } else {
      const {
        onUpdateChecked: e,
        "onUpdate:checked": d
      } = t, {
        nTriggerFormInput: r,
        nTriggerFormChange: z
      } = l;
      e && f(e, !0), d && f(d, !0), r(), z(), m.value = !0;
    }
  }
  function p() {
    c.value || i.value || C();
  }
  function S() {
    p(), o.value && (o.value.checked = i.value);
  }
  function b() {
    a.value = !1;
  }
  function y() {
    a.value = !0;
  }
  return {
    mergedClsPrefix: n ? n.mergedClsPrefixRef : D(t).mergedClsPrefixRef,
    inputRef: o,
    labelRef: h,
    mergedName: k,
    mergedDisabled: c,
    renderSafeChecked: i,
    focus: a,
    mergedSize: g,
    handleRadioInputChange: S,
    handleRadioInputBlur: b,
    handleRadioInputFocus: y
  };
}
export {
  q as radioBaseProps,
  E as radioGroupInjectionKey,
  H as setup
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/radio/src/use-radio.js
// module id = 931
// module chunks = 41